export default {
  edit: "network:edit",
  create: "network:create",
  delete: "network:delete",
  view: "network:view",
};
